<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">
                <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                    <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_FIX_SIZE_TYPE_ADD')" @click="showCadastreFixSizeTypeEditModal(null)">{{$t("action.add")}}</button>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>Код</th>
                        <th>Текст</th>
                        <th>Текст(ru)</th>
                        <th>Кв.м категория</th>
                        <th>Тузатиш бино турлари</th>
                        <th class="text-center">{{$t("realEstate.field.action")}}</th>
                    </tr>
                    </thead>
                    <tbody v-if="!loading && results && results.data">
                    <tr v-for="result in results.data" :key="result.id">
                        <td>{{result.code}}</td>
                        <td>{{result.name}}</td>
                        <td>{{result.nameRu}}</td>
                        <td>{{result.data && result.data.values['sq_category'].name}}</td>
                        <td>{{result.buildingFix ? result.buildingFix.name : ''}}</td>
                        <td class="td-actions text-center">
                            <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showCadastreFixSizeTypeEditModal(result)">
                                <i class="fa fa-edit"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CadastreFixSizeTypeEditModal />
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import CadastreFixSizeTypeEditModal from '@/views/config/cadastre/CadastreFixSizeTypeEditModal'
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            'b-pagination': bPagination,
            CadastreFixSizeTypeEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                cadastreBuildingFields: [],
                cadastreBuildingFixSizes: [],
                cadastreBuildingFieldReferences: {}
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.get('/cadastre/fix-size-type/init')
                    .then(res => {
                        vm.initResponse(res);
                        vm.initData();
                    }, err => {
                        console.log(err);
                    });

            },
            initResponse(res) {
                const data = res.data;
                this.cadastreBuildingFieldReferences = data.references;
                this.cadastreBuildingFields = data.fields;
                this.cadastreBuildingFixSizes = data.fixSizes;
            },
            initData() {
                const vm = this;
                this.$http.post('/cadastre/fix-size-type/list', this.filter)
                    .then(res => {
                        let editData = res.data;
                        if (editData.data) {
                            editData.data.forEach((result) => {
                                if (result.data && result.data.values) {
                                    vm.cadastreBuildingFields.forEach((field) => {
                                        if (field.code && !field.system && result.data.values.hasOwnProperty(field.code)) {
                                            const fieldValue = result.data.values[field.code];
                                            if (fieldValue) {
                                                const fieldResult = vm.getReferenceById(field.reference.code, fieldValue.id)
                                                if (fieldResult) {
                                                    result.data.values[field.code].name = fieldResult.name
                                                }
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        vm.results = editData;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            showCadastreFixSizeTypeEditModal(data) {
                if (data) {
                    const vm = this;
                    data.references = vm.cadastreBuildingFieldReferences
                    data.fields = vm.cadastreBuildingFields
                    data.fixSizes = vm.cadastreBuildingFixSizes
                }
                this.$eventBus.$emit('showCadastreFixSizeTypeEditModal', data);
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList()
            this.$eventBus.$on('onCadastreFixSizeTypeChanged', () => {
                this.initList()
            })
        }
    }
</script>

<style scoped>

</style>